import React, { useState } from "react";
import { PageHeader, Panel, Table, Pager, KpiCard, KpiGrid, useAdminQuery, RefreshButton, Unavailable, StatusChip, fmtDate, INK, MUTE, BORDER } from "../_shared";

export default function AdminCredits() {
  const [page, setPage] = useState(1);
  const [op, setOp] = useState("");
  const r = useAdminQuery("/admin/credits/transactions", { page, page_size: 25, op: op || undefined });
  const k = r.data?.kpi || {};

  return (
    <div data-testid="admin-credits-page">
      <PageHeader title="Credits & Transactions"
        subtitle="Read-only ledger. Wallet mutations happen only through the backend transaction model."
        right={<RefreshButton loading={r.loading} onClick={r.refresh} />} />

      <KpiGrid>
        <KpiCard label="Granted"  value={k.granted}  testId="kpi-granted"/>
        <KpiCard label="Spent"    value={k.spent}    testId="kpi-credits-spent"/>
        <KpiCard label="Reserved" value={k.reserved} hint="not yet captured" testId="kpi-reserved"/>
        <KpiCard label="Refunded" value={k.refunded} testId="kpi-refunded"/>
        <KpiCard label="Net outstanding" value={k.net_outstanding} testId="kpi-net"/>
      </KpiGrid>

      <Panel>
        <div style={{ display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
          <select value={op} onChange={(e) => { setOp(e.target.value); setPage(1); }}
                   data-testid="admin-credits-op"
                   style={{ padding: "8px 12px", borderRadius: 10,
                             border: `1px solid ${BORDER}`, fontSize: 13 }}>
            <option value="">All operations</option>
            <option value="grant">Grant</option>
            <option value="spend">Spend</option>
            <option value="refund">Refund</option>
          </select>
        </div>

        {r.loading ? <Loading /> : r.error ? <Unavailable error={r.error} /> : (
          <>
            <Table cols={[
              { label: "Ledger",   render: (x) => <code style={{ fontSize: 11 }}>{(x.ledger_id || "").slice(0,10)}</code> },
              { label: "User",     render: (x) => <code style={{ fontSize: 11 }}>{(x.user_id || "").slice(0,14)}</code> },
              { label: "Op",       render: (x) => <StatusChip status={x.op} /> },
              { label: "Amount",   render: (x) => (x.amount || 0).toLocaleString() },
              { label: "Reason",   render: (x) => <span style={{ color: MUTE, fontSize: 11 }}>{x.reason}</span> },
              { label: "Related",  render: (x) => x.related ? <code style={{ fontSize: 11 }}>{x.related.slice(0,10)}</code> : "—" },
              { label: "When",     render: (x) => fmtDate(x.created_at) },
            ]} rows={r.data?.rows || []} keyFn={(x) => x.ledger_id} testId="admin-credits-table" />
            <Pager page={page} pageSize={25} total={r.data?.total || 0} onPage={setPage} />
          </>
        )}
      </Panel>
    </div>
  );
}
function Loading() { return <div style={{ padding: 30, color: MUTE, fontSize: 13, textAlign: "center" }}>Loading…</div>; }
